export const GOOGLE_MAP_KEY = 'gme-marriottinternational';
export const URL_CONSTANTS = {
  PLACEHOLDER_IMAGE:
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4nGNiOAMAANUAz5n+TlUAAAAASUVORK5CYII=',
  BRIGHTCOVE_PLAYER_DOMAIN: 'https://players.brightcove.net',
};
export const GOOGLE_MAP_VAL_KEY = 'AIzaSyCCW6WUQGP6GoOAd-iPkaiS53x3SmhXMgQ';
export const GOOGLE_MAP_VAL_KEY2 = 'AIzaSyCseruNteINWJ8NVUINqSHRDOhG0NZVdZQ';

export const CN_YEAR = '年';
export const CN_MONTH = '月';
export const CN_FLEXIBLE_FORMAT_YEAR_MONTH = `YYYY${CN_YEAR} M${CN_MONTH}`;

export const USER_LOGGED_IN = 'ev:userDetailsReady';
export const TAB_DIRTY_SESSION = 'tab_dirty_session';
export const TEST_HOSTNAME = 'https://ram-test5.ose-dev39-vxbyr.cloud.marriott.com';
export enum QrvType {
  EXPLORE = 'explore',
}

export enum FlyoutType {
  EXPLORE_RATE_SIGN_IN = 'explore-rate-sign-in-flyout',
}

export const ACCOUNT_MODAL_OPEN_EVENT = 'accountModalOpen';
export const ACCOUNT_FLYOUT_MODAL_ID = 'global-header-sign-in';
